import Button from "../../minicomponents/Button";
import { useEffect, useState } from "react";
import { useUser } from "../../context/Usercontext";
import { supabase } from "../../supabase/client";

let PostTweet = function () {
  let [textPost, setTextPost] = useState("");
  let [textValid, setTextValid] = useState(false);
  let { user, userObject, posts, setPosts } = useUser();
  let [loadingPosting, setLoadingPosting] = useState(false);

  //
  useEffect(() => {
    if (textPost.length <= 100 && textPost.length > 0) {
      setTextValid(true);
    } else {
      setTextValid(false);
    }
  }, [textPost]);

  //

  let handlePost = async (e) => {
    e.preventDefault();
    console.log(userObject);
    console.log(user);
    if (textValid) {
      setLoadingPosting(true);
      try {
        let { data, error } = await supabase
          .from("main-facts")
          .insert({ fact_content: textPost, user_id: userObject.id })
          .select();
        console.log(data[0]);
        setPosts([...data, ...posts]);
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingPosting(false);
        setTextPost("");
      }
    }
  };

  return (
    <div className="post-tweet-element ">
      <span className="post-tweet-element-title">Post something</span>
      <form className="own-form" onSubmit={handlePost}>
        <textarea
          className="post-tweet-textarea button-width-100"
          placeholder="Type something cool..."
          value={textPost}
          onChange={(e) => setTextPost(e.target.value)}
        ></textarea>
        {textValid ? (
          <Button loadingPosting={loadingPosting} buttonStyle="button-style-1">
            {" "}
            {loadingPosting ? "Posting..." : "Share"}
          </Button>
        ) : null}
        <span className="post-tweet-message-characters">
          {!textValid && textPost.length > 0
            ? "The characters must be less than 100"
            : null}
        </span>
      </form>
    </div>
  );
};

export default PostTweet;
